import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearUserState } from '../../../reducers/userReducers';
import { clearMenuState } from '../../../reducers/menuReducers';
import { clearLangCodeState } from '../../../reducers/langCodeReducers';
import { getUserInfo } from '../../../reducers/selectors/selectors';
import { store } from '../../../store';
import userImg from '../../../assets/img/basic_user.jpg';
import Profile_001 from './profile_001';

const DropdownProfile = () => {
	const dispatch = useDispatch();

	const handleLogout = () => {
		// 로그아웃 클릭 시 사용자 상태를 초기화하는 액션 디스패치
		dispatch(clearUserState());
		dispatch(clearMenuState());
		dispatch(clearLangCodeState());

		// localStorage에서 langCodeInfo 제거
		localStorage.removeItem('langCodeInfo');
	};

	const userInfo                    = getUserInfo(store.getState());
	const [showModal, setShowModal]   = useState(false);

	const handleOpenModal = () => {
		setShowModal(true);
	};

	return (
		<div className="navbar-item navbar-user dropdown">
			<a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center me-3" data-bs-toggle="dropdown">
				{/* <img src="/assets/img/user/user-13.jpg" alt="" />  */}
				{/* <img src={userImg} alt={userInfo.name} />  */}
				{userInfo && <img src={userImg} alt={userInfo.name} />}
				<span>
					{userInfo && <span className="d-none d-md-inline">{userInfo.name}</span>}
					<b className="caret"></b>
				</span>
			</a>
			<div className="dropdown-menu dropdown-menu-end me-1">
				<a href="#/" className="dropdown-item" onClick={handleOpenModal}><i className="fa-solid fa-user"></i> My Profile</a>

				{/* Profile_001 모달 */}
				{showModal && (
					<Profile_001 showModal={showModal} setShowModal={setShowModal} userInfo={userInfo} />
				)}
				{/* <a href="#/" className="dropdown-item d-flex align-items-center">
					Inbox
					<span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span> 
				</a>
				<a href="#/" className="dropdown-item">Calendar</a>
				<a href="#/" className="dropdown-item">Settings</a> */}
				<div className="dropdown-divider"></div>
				<Link to="/login" className='dropdown-item' style={{ color: 'red' }} onClick={handleLogout}><i className="fa-solid fa-power-off"></i> Sign Out</Link>
			</div>
		</div>
	);
};

export default DropdownProfile;